import logoUrl from "../assets/cc-logo.png";
import markUrl from "../assets/cc-mark.png";

export type BrandProps = {
  /** Texto pequeno abaixo do nome (ex.: "CENTRAL DE GESTÃO"). */
  tag?: string;
  href?: string;
  size?: "sm" | "md";
  /** "full" mostra o logo completo (telas de entrada); "compact", o símbolo com o nome. */
  variant?: "compact" | "full";
};

export function Brand({ tag = "CENTRAL DE GESTÃO", href = "/", size = "md", variant = "compact" }: BrandProps) {
  if (variant === "full") {
    return (
      <a className="brand brand-full" href={href} aria-label="CCControl, Centro Cirúrgico Control, início">
        <img className="brand-logo" src={logoUrl} alt="" />
        {tag ? <small>{tag}</small> : null}
      </a>
    );
  }
  return (
    <a
      className={size === "sm" ? "brand sm" : "brand"}
      href={href}
      aria-label="CCControl, Centro Cirúrgico Control, início"
    >
      <img className="brand-icon" src={markUrl} alt="" />
      <span>
        <span className="brand-cc">cc</span>
        <span className="brand-control">Control</span>
        <small>{tag}</small>
      </span>
    </a>
  );
}
